const tokenList = (state) => state.tokenList

export default {
  tokenList
}



// WEBPACK FOOTER //
// ./src/store/modules/integrationTokens/getters.js